export default __webpack_public_path__ + "static/media/upload.760ff6b4.svg";